import { Theme } from '@material-ui/core/styles';

import { createTheme } from '@material-ui/core';
import Overrides from './overrides';
import paletteOverrides from './palette';

const theme: Theme = createTheme({
  palette: paletteOverrides,
  typography: {
    fontFamily: 'SimplonBp',
  },
  overrides: Overrides,
  props: {
    MuiTextField: {
      variant: 'outlined',
      margin: 'normal',
    },
    MuiSelect: {
      variant: 'outlined',
    },
  },
});

export default theme;
